import { UserInterface } from "../interface/users.interface";

export const inputStyle =
  "w-full bg-honeConnectGray50 border border-solid border-honeConnectGray200 text-honeConnectGray200 p-3.5 rounded-md focus:outline-1 focus:outline focus:outline-honeConnectPurple font-normal";

export function twoDecimalPlace(value: number) {
  if (value) return Number(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  else return "0";
}

export function formatDate(date: string, format?: string) {
  let d = new Date(date);

  if (format === "time") {
    return d.toLocaleTimeString("en-US");
  } else if (format === "date") {
    let y = d.getFullYear();
    let m = d.getMonth();
    let dd = d.getDate();
    let months_of_year = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    return `${months_of_year[m] + " " + dd + ", " + y}`;
  } else {
    return d.toDateString() + " " + d.toLocaleTimeString("en-US");
  }
}

// Funnel stage colour tags, highest stage reached wins.
// NOTE: no "paid" field exists on the user object yet, so PURPLE is not assigned;
// GREEN ("code received") is approximated by `is_verified`.
export const getFunnelStage = (user: UserInterface) => {
  if (user.elite_status === "APPROVED" || user.elite_status === "ACTIVE")
    return { label: "Elite member", color: "#3B82F6" };
  if (user.is_verified && user.is_verified !== "0")
    return { label: "Code received", color: "#22C55E" };
  if (user.is_email_verified)
    return { label: "Email verified", color: "#F97316" };
  if (user.is_phone_verified)
    return { label: "Phone verified", color: "#EAB308" };
  return { label: "Opt-in", color: "#EF4444" };
};

export const FUNNEL_LEGEND = [
  { label: "Opt-in", color: "#EF4444" },
  { label: "Phone verified", color: "#EAB308" },
  { label: "Email verified", color: "#F97316" },
  { label: "Code received", color: "#22C55E" },
  { label: "Paid", color: "#A855F7" },
  { label: "Elite member", color: "#3B82F6" },
];

export const csvCell = (v: unknown) => `"${String(v ?? "").replace(/"/g, '""')}"`;

// Real USD value supplied by the backend; "-" when the API doesn't return one.
export const formatUsd = (amount: any) => {
  if (amount === null || amount === undefined || amount === "") return "-";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(Number(amount));
};

// Pick the NGN or USD display. `usdValue` is the backend's USD field for the same amount.
export const formatMoney = (
  currency: "NGN" | "USD",
  ngnValue: any,
  usdValue: any
) => (currency === "USD" ? formatUsd(usdValue) : formatAmount(ngnValue));

export const formatAmount =(amount:any) => {
  const formattedAmount = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "NGN",
  }).format(Number(amount ?? "0.00"));

  return formattedAmount;
};

/** The API client rejects with a plain string; this also covers Error objects and unknowns */
export const getErrorMessage = (error: unknown): string => {
  if (typeof error === "string" && error.trim()) return error;
  if (error instanceof Error && error.message) return error.message;
  return "Something went wrong. Please try again.";
};